"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _router = require("@reach/router");

var _PrivateEditor = _interopRequireDefault(require("../editor/PrivateEditor"));

var _redux = require("../../redux"); // import components


var PrivateRouter = function PrivateRouter(props) {
  var _props$pageContext;

  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      config = _ref.cms.config; // We don't need to load the PrivateEditor if page is published


  if ((props === null || props === void 0 ? void 0 : (_props$pageContext = props.pageContext) === null || _props$pageContext === void 0 ? void 0 : _props$pageContext.status) === 'publish') {
    return /*#__PURE__*/_react.default.cloneElement(props === null || props === void 0 ? void 0 : props.defaultComponent, {
      source: config === null || config === void 0 ? void 0 : config.source
    });
  }

  return /*#__PURE__*/_react.default.createElement(_router.Router, null, /*#__PURE__*/_react.default.createElement(_PrivateEditor.default, (0, _extends2.default)({
    path: '*'
  }, props)));
};

var _default = PrivateRouter;
exports.default = _default;